// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"App_parentContainer__1BpSx"};